import Select from "react-select";

// Components
import Button from "components/v1/Button";

// Assets
import IPlus from "assets/i-plus.js";
import XIconSrc from "assets/cross.svg";
import { useGlobalCtx } from "contexts/GlobalContext";

const FormLokasiDanProperti = ({
  onSelect,
  selectedLocations,
  onOpenModalPilihLokasi,
  options,
  control,
  Controller,
}) => {
  const { listAreaOnlyComplete } = useGlobalCtx();

  const getActiveListingType = (value) => {
    if (value === 1) {
      return "Jual";
    }
    return "Sewa";
  };

  return (
    <div>
      <div className="flex items-center gap-2 py-2">
        <p className="w-[126px] py-2 text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#252526]">
          Tipe Listing
          <span className="text-[#FD4949] font-inter-semibold">*</span>
        </p>
        <Controller
          control={control}
          name="listing_type_id"
          render={({ field }) => (
            <>
              <div className="flex items-center gap-2">
                <input
                  type="radio"
                  name={field.name}
                  checked={field.value === 1}
                  onChange={() => field.onChange(1)}
                  className="w-[16px] h-[16px] select:bg-[#BEAF87]"
                />
                <span className="text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#252526]">
                  {getActiveListingType(1)}
                </span>
              </div>

              <div className="flex items-center gap-2">
                <input
                  type="radio"
                  name={field.name}
                  checked={field.value === 2}
                  onChange={() => field.onChange(2)}
                  className="w-[16px] h-[16px] select:bg-[#BEAF87]"
                />
                <span className="text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#252526]">
                  {getActiveListingType(2)}
                </span>
              </div>
            </>
          )}
        />
      </div>
      <div className="flex items-center gap-2 py-2">
        <p className="w-[126px] py-2 text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#252526]">
          Tipe Property
          <span className="text-[#FD4949] font-inter-semibold">*</span>
        </p>
        <Controller
          control={control}
          name="property_type_id"
          render={({ field }) => (
            <Select
              value={
                options?.find((option) => option.value === field.value) || null
              }
              onChange={(selectedOption) =>
                field.onChange(selectedOption?.value || null)
              }
              options={options}
              placeholder="Pilih tipe property..."
              className="w-[calc(100%-126px)]"
              isSearchable={false}
              styles={{
                control: (provided) => ({
                  ...provided,
                  fontSize: "13px",
                  lineHeight: "21px",
                  letterSpacing: "-0.4px",
                  fontFamily: "Inter",
                  color: "#252526",
                  padding: "2px",
                  borderRadius: "4px",
                  border: "1px solid #D8D8D9",
                  minHeight: "auto",
                }),
                placeholder: (provided) => ({
                  ...provided,
                  color: "#D8D8D9",
                }),
                singleValue: (provided) => ({
                  ...provided,
                  color: "#252526",
                }),
              }}
            />
          )}
        />
      </div>
      <div className="gap-2 py-2">
        <p className="w-[126px] py-2 text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#252526]">
          Lokasi Pencarian
          <span className="text-[#FD4949] font-inter-semibold">*</span>
        </p>
        <div className="overflow-y-auto rounded-[4px] border-[1px] border-solid border-[#D8D8D9] p-2 items-start justify-start flex flex-wrap gap-2">
          <Button
            icon={IPlus}
            iconColor="#252526"
            text="Pilih Lokasi"
            type="secondary"
            size="xs"
            className="w-fit h-[24px]"
            onClick={onOpenModalPilihLokasi}
          />
          {!!selectedLocations?.length && !!listAreaOnlyComplete?.length && (
              listAreaOnlyComplete
                ?.filter((item) => selectedLocations.includes(item.id))
                ?.map((item) => (
                  <div key={item.id} className="flex items-center justify-center h-6 pl-2 gap-2 pr-1 rounded-[2px] bg-[#E6E7E8] w-fit">
                    <p className="text-[11px] leading-[17px] tracking-[-0.4px] font-inter text-[#252526]">
                      {item.name}
                    </p>
                    <div
                      onClick={() => onSelect(item.id)}
                      className="w-[16px] h-[16px] flex items-center justify-center bg-white rounded-[2px] cursor-pointer"
                    >
                      <img
                        src={XIconSrc}
                        alt="Remove"
                        className="w-[12px] h-[12px]"
                      />
                    </div>
                  </div>
                ))
          )}
        </div>
        <p className="text-[11px] leading-[17px] tracking-[-0.4px] font-inter text-[#808285] mt-1">
          Bisa pilih lebih dari satu lokasi.
        </p>
      </div>
    </div>
  );
};

export default FormLokasiDanProperti;
